import { UPDATE_PROGRESS } from "@/constants/ActionTypes";

export const updateAPIProgress = (enabled: boolean, message?: string) => ({
  type: UPDATE_PROGRESS,
  payload: {
    apiProgressStatus: {
      enabled,
      message,
    },
  },
});

export const updateLibraryProgress = (enabled: boolean, message?: string) => ({
  type: UPDATE_PROGRESS,
  payload: {
    libraryProgressStatus: {
      enabled,
      message,
    },
  },
});
